// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I8M00","content":"styles_content__2Sbl8"};